import { useCallback, useMemo } from 'react';

import { useAccount } from 'modules/account/hooks/useAccount';
import { IUseQueryProps } from 'store/queries/types';
import { useAppSelector } from 'store/useAppSelector';
import { getQueryParams } from 'store/utils/getQueryParams';

import {
  useGetUIProfileConfigQuery,
  useLazyGetUIProfileConfigQuery,
  selectUIProfileConfig,
  selectUIProfileConfigLoading,
} from '../actions/getUIProfileConfig';

interface IUseUiProfileConfigProps extends IUseQueryProps {}

export const useUIProfileConfig = ({
  skipFetching,
}: IUseUiProfileConfigProps) => {
  const { group } = useAccount();

  const params = useMemo(() => ({ group }), [group]);

  const { refetch: handleRefetchUIProfileConfig } = useGetUIProfileConfigQuery(
    getQueryParams({ params, skipFetching }),
  );

  const [fetchLazy] = useLazyGetUIProfileConfigQuery();

  const handleFetchUIProfileConfig = useCallback(
    () => fetchLazy(params),
    [fetchLazy, params],
  );

  const uiProfileConfig = useAppSelector(state =>
    selectUIProfileConfig(state, params),
  );
  const isUIProfileConfigLoading = useAppSelector(state =>
    selectUIProfileConfigLoading(state, params),
  );

  return {
    handleFetchUIProfileConfig,
    handleRefetchUIProfileConfig,
    isUIProfileConfigLoading,
    uiProfileConfig,
  };
};
